import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`The GitHub presentation template is available for use in the Google Slides template gallery.`}</p>
    <h2>{`How to use`}</h2>
    <h3>{`From the Template Gallery`}</h3>
    <p>{`In Google Slides, start a presentation with the template by selecting it from the Template Gallery.`}</p>
    <img width="656" alt="Select the GitHub presentation template to get started" src="https://user-images.githubusercontent.com/10384315/101223163-3f230a80-3640-11eb-8623-4f6d9d5cf926.png" />
    <p>{`If you do `}<strong parentName="p">{`not`}</strong>{` see the template, expand the `}<strong parentName="p">{`Template Gallery`}</strong>{` by clicking on the `}<strong parentName="p">{`Template Gallery ↕️`}</strong>{` button in the top right of the gallery area. This will expand and all available templates for GitHub will be available.`}</p>
    <img width="656" alt="The Template Gallery ↕️ button in the top right of the gallery area" src="https://user-images.githubusercontent.com/10384315/101223398-d25c4000-3640-11eb-8d88-99f503379b7d.png" />
    <h4>{`Help! I can't see the template gallery.`}</h4>
    <p>{`If the template gallery does not appear on your Google Slides homescreen follow the steps below to make it visible.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Open the menu by clicking on the `}<strong parentName="p">{`hamburger menu`}</strong>{` (button with three stacked lines) in the top left of the screen.`}</p>
        <img width="656" alt="Open the menu in the top left of the screen" src="https://user-images.githubusercontent.com/10384315/101223162-3f230a80-3640-11eb-93af-f73468751306.png" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`Settings`}</strong></p>
        <img width="279" alt="Click 'Settings'" src="https://user-images.githubusercontent.com/10384315/101223160-3f230a80-3640-11eb-9907-35582a4ed37a.png" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<strong parentName="p">{`Templates`}</strong>{` section, check the box next to `}<strong parentName="p">{`Display recent templates on homescreen`}</strong>{`.`}</p>
        <img width="656" alt="From settings, check the box Display recent templates on homescreen" src="https://user-images.githubusercontent.com/10384315/101223158-3df1dd80-3640-11eb-8348-65ff9695e214.png" />
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<strong parentName="p">{`OK`}</strong>{`. You should now see the `}<strong parentName="p">{`Template Gallery`}</strong>{` on your homescreen.`}</p>
      </li>
    </ol>
    <h3>{`From a blank presentation`}</h3>
    <p>{`If you have already created a presentation file in Google Slides, the GitHub presentation template can still be applied using the "Theme" tab.`}</p>
    <p>{`Click the `}<strong parentName="p">{`Theme`}</strong>{` button to open the theme chooser.`}</p>
    <img width="504" alt="Screenshot of the theme chooser in Google Slides" src="https://user-images.githubusercontent.com/10384315/101224016-4d722600-3642-11eb-9bc5-f309bf17c2d1.png" />
    <p>{`In the Themes sidebar that opens on the right side of the screen, click `}<strong parentName="p">{`Import theme`}</strong>{` at the bottom`}</p>
    <img width="297" alt="Click import theme" src="https://user-images.githubusercontent.com/10384315/101224053-74c8f300-3642-11eb-97e0-002407b31400.png" />
    <p>{`A pop up modal will appear. In the search box type, "GitHub presentation template" and then select the presentation file to import the theme.`}</p>
    <img width="656" alt="Search for the GitHub presentation template to select the theme" src="https://user-images.githubusercontent.com/10384315/101223918-07b55d80-3642-11eb-8d74-c1f221237362.png" />
    <Note mdxType="Note">
      <p>{`😕 `}<strong parentName="p">{`Having trouble?`}</strong>{` Message us in `}<a parentName="p" {...{
          "href": "https://github.slack.com/messages/C0ZCGGGJ2"
        }}>{`#design-systems`}</a>{` for assistance.`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      